
import myaxios from '@/myaxios.js'

const state = {
    ipAddress: ``
}
const mutations = {
    SET_LOCALIP: (state, ipAddress) => {
        state.ipAddress = ipAddress
    }
}

const actions = {
    LOAD_LOCAL_IP: function({ dispatch, commit, getters }) {
        return new Promise(resolve => {
            myaxios.post(`/api/Anonymous/InternalServer/GetMyIp`).then((data) => {
                commit(`SET_LOCALIP`, data)
                resolve()
            }).catch(error => {
                console.log(error)
            })
        })
    }
}

const getters = {
    ipAddress: (state, getters) => {
        return state.ipAddress
    }
}
export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/localip.js